'use strict';

/**
 * This scripts performs the AJAX request to track the traffic source and used keywords in case
 * it comes from a search engine.
 *
 * Each request is intended to be done only once per session (this is controlled using SessionStorage).
 * Anyway, this is controlled in the backend with $_SESSION.
 */
(function (doc) {
    /**
     * Session storage flag name.
     *
     * @type {string}
     */
    var SOURCE_CONTROL = 'source-control',

    /**
     * Session storage adapter.
     */
    storage = {
        get: function get(key)
        {
            return sessionStorage.getItem(key);
        },
        set: function set(key, value)
        {
            sessionStorage.setItem(key, value);
        }
    };

    /**
     * Get the value of the given param from the URL query string.
     *
     * @param {string} paramName
     * @returns {*} Param value or undefined if wasn't found.
     */
    function getParam(paramName)
    {
        var queryString = doc.location.search,
            params = void 0;

        if (!queryString) {
            return undefined;
        }

        params = queryString.substring(1).split('&');

        for (var i = 0, length = params.length; i < length; i++) {
            var parts = params[i].split('=');

            if (parts[0] === paramName) {
                return parts[1] || 1;
            }
        }

        return undefined;
    }

    /**
     * Builds a params string (in the format param1=value1&param2=value2) from an object.
     *
     * @param {object} params
     * @returns {string}
     */
    function buildParams(params)
    {
        return Object.keys(params).filter(function (key) {
            return params[key] !== undefined;
        }).map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');
    }

    /**
     * Makes a POST ajax request.
     *
     * @param {string} url
     * @param {object} params
     */
    function postAjax(url, params)
    {
        var xhr = new XMLHttpRequest();

        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(buildParams(params));
    }

    /**
     * On script execution, tracks the source by performing an AJAX request.
     * Multiple tracking request on the same session are avoided by saving a flag on SessionStorage.
     */
    if (!getParam('cmp') && !storage.get(SOURCE_CONTROL)) {
        postAjax('/tracking/source_control', {
            referer: doc.referrer,
            uri: doc.location.href,
            utm_campaign: getParam('cmp'),
            affiliate_cross: getParam('affiliate_cross'),
            source: getParam('source')
        });

        storage.set(SOURCE_CONTROL, '1');
    }

    /**
     * Campaign AJAX requests with cmp param (if exists).
     */
    if (getParam('cmp')
        && getParam('cmp').length >= 1
        && getParam('source')
        && getParam('source').length >= 1
    ) {
        postAjax('/tracking/campaign_control', {
            cmp: getParam('cmp'),
            source: getParam('source')
        });
    }
}(document));
